<docs>
# Notification Flag

> NOTE: this docs defined at **docs** section inside NotiFLag.vue module

Notification FLag UI Set


<!-- STORY -->

### Example

>Normal

```javascript
let options = {type: 'error'}
this.$mtNotiFlag('title', 'subTitle', options)
```

>Auto remove

```javascript
let options = {type: 'info', autoClose: true}
this.$mtNotiFlag('title', 'subTitle', options)
```

>Callback after close

```javascript
let options = {type: 'success', onClose: () => {
  //do something
}}
this.$mtNotiFlag('title', 'subTitle', options)
```

### Props

| Property | Description       | Type   | Accepted Values               | Default |
|----------|-------------------|--------|-------------------------------|---------|
| title    | title             | String | —                             | —       |
| subTitle | sub title         | String | —                             | —       |
| options  | object of options | Object | {type}/{autoClose}/{onClose} | —       |


### Options
| Property  | Description            | Type    | Accepted Values              | Default     |
|-----------|------------------------|---------|------------------------------|-------------|
| type      | type of flag           | String  | error/warning/success/info   | warning     |
| autoClose | if true, flag close after 3 seconds | Boolean | true/false | false       |
| onClose   | fire when flag closing | Function  | -   | -     |



</docs>
<template>
  <transition name="slide-fade">
    <div :id="`mt-noti-flag-${mtNotiId}`" v-if="visibleFlag" class="mt-noti-flag mt-zindex--top" :class="'mt-noti-flag--'+type" :style="{top:mtNotiPositionTop + 'px'}">
      <span class="rectangle" />
      <mt-icon :iconName="iconName" :color="iconColor" />
      <span class="title mt-font--body20">{{titlePrefix}}: {{title}}</span>
      <span class="sub-title mt-font--body10">{{subTitle}}</span>
      <mt-icon class="close" iconName="close"  @click="handleClickClose"/>
    </div>
  </transition>
</template>

<script>
import MtIcon from '../icon/Icon.vue'
export default {
  name: 'mt-noti-flag',
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'warning'
    },
    visibleFlag: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MtIcon
  },
  data () {
    return {
      colseIconColor: '',
    }
  },
  computed: {
    titlePrefix() {
      if(this.type == 'error') return 'Error'
      if(this.type == 'warning') return 'Warning'
      if(this.type == 'success') return 'Success'
      if(this.type == 'info') return 'Information'
    },
    iconName() {
      if(this.type == 'error') return 'error-circle'
      if(this.type == 'warning') return 'warning-circle'
      if(this.type == 'success') return 'check-circle'
      if(this.type == 'info') return 'information-circle'
    },
    iconColor() {
      if(this.type == 'error') return '#f44336'
      if(this.type == 'warning') return '#FFC107'
      if(this.type == 'success') return '#00c853'
      if(this.type == 'info') return '#7364ff'
    }
  },

  methods: {
    handleClickClose(evt) {
      this.close()
    },
  },

}
</script>
<style src="./NotiFlag.scss" lang="scss">
</style>



// WEBPACK FOOTER //
// NotiFlag.vue?a3c39166